import { z } from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { PaymentDeferralCancellationReason } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CancelPaymentDeferralWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('cancelPaymentDeferralWorkoutPlan'),
  workoutPlanId: WorkoutPlanId,
  isDraftPlan: z.boolean(), // for audit log
  terminationDate: z.date(),
  reason: PaymentDeferralCancellationReason,
});
export type CancelPaymentDeferralWorkoutPlanEvent = z.infer<typeof CancelPaymentDeferralWorkoutPlanEvent>;
